export enum MediaType {
    OneToOne = '1:1',
    TwoToOne = '2:1',
    SixteenToNine = '16:9'
}
